import * as React from 'react';
import ICommentComponent, { TCommentComponent } from './ICommentComponent';
import Post from '../Post/Post';
import CompaniesPageService from '@services/CompaniesPage.service';
import IPost from '../Post/IPost';
import { pushNotify } from '@appComponents/Notification/Notification';
import { animateScrollTo, getAxiosErrorMessage, isAndroidDevice } from '@features/utils/functions';
import TextEditor from '../TextEditor/TextEditor';

import * as style from './CommentComponentStyle.module.scss'
import * as post from '../Post/PostStyle.module.scss';

export default class CommentComponent extends React.Component<ICommentComponent, TCommentComponent> {
  editorRef: TextEditor;

  state: TCommentComponent = {
    allVisible: false,
    commentsList: this.props.commentsList,
    repliesCount: this.props.repliesCount,
    showBtn: false,
  };

  private input: React.RefObject<HTMLDivElement>;
  constructor(props: ICommentComponent) {
    super(props);
    this.input = React.createRef();
  }

  publish = () => {
    const path = this.props.isDiscussion ? 'public' : 'private';
    const values = this.editorRef.sendValueToParent();
    const data = {
      pitch_id: this.props.pitchId,
      message: values.message,
      parent_id: this.props.parentId,
    };

    CompaniesPageService.postFeed(data, path)
      .then((res) => {
        const newPosts = Array.from(this.state.commentsList);
        newPosts.push(res.data);
        this.setState({
          allVisible: true,
          commentsList: newPosts,
          repliesCount: this.state.repliesCount + 1,
          showBtn: false,
        });
      }).catch((error) => {
        window.scrollTo(0, 0);
        pushNotify('error', getAxiosErrorMessage(error), 5000);
      });
  }

  displayPosts = () => {
    const commentsList = this.state.allVisible ? this.state.commentsList : this.state.commentsList.slice(0, 2);

    return commentsList.map((elem: IPost) => (
      <div
        key={elem.id}
        className={post.postContainer}
      >
        <Post
          {...elem}
          byOwner={false}
          isComment={true}
          repliedPitchName={false}
        />
      </div>
    ));
  }

  setButtonStatus = (showBtn: boolean) => {
    this.setState({ showBtn });
  }

  displayCommentBox = () => {
    return(
      <div onClick={() => this.showPosts(true)} ref={this.input}>
        <TextEditor
          ref={(editor) => { this.editorRef = editor as TextEditor; }}
          setButtonStatus={this.setButtonStatus}
          avatar={this.props.profileAvatar}
          disableImage={true}
          disableVideo={true}
          disabledForAndroid={isAndroidDevice()}
        />
        {this.state.showBtn &&
          <button
            onClick={this.publish}
            className={style.publishBtn}
          >
            Publish
          </button>
        }
      </div>
    );
  }

  showPosts = (focusInput: boolean = false) => {
    if (this.state.allVisible || this.state.repliesCount <= 2) {
      return;
    }

    const path = this.props.isDiscussion  ? 'public' : 'private';
    CompaniesPageService.getFeed(
      undefined,
      path,
      this.props.pitchId,
      this.props.parentId,
      this.state.repliesCount
    ).then((res) => {
      this.setState({ allVisible: true, commentsList:res.data.items }, () => {
        if (focusInput && this.input && this.input.current) {
          animateScrollTo(undefined, this.input.current, window.innerHeight / 2);
        }
      });
    });
  }

  render() {
    const { repliesCount } = this.state;
    return (
      <div>
        <div
          className={[
            style.commentsList,
            this.state.allVisible || repliesCount <= 2  ? style.commentsListAll : null,
          ].join(' ')}
        >
          {this.displayPosts()}
        </div>
        {
          repliesCount > 2 && !this.state.allVisible &&
          <div className={style.loadMore} onClick={() => this.showPosts()}>
            {`Show ${repliesCount - 2} more`}
          </div>
        }
        {!this.props.externalForum && this.displayCommentBox()}
      </div>
    );
  }
}
